// eslint-disable-next-line max-classes-per-file
import { getInstance } from '#/auth';
import store from '#/store';

export class RPCSession {
  constructor() {
    this.error = undefined;
    this.errorMessage = undefined;
  }

  async headers() {
    try {
      const idToken = await getInstance().getTokenSilently();
      const metadata = {
        Authorization: `bearer ${idToken}`,
      };
      return Promise.resolve(metadata);
    } catch (error) {
      console.error('error retrieving user token for headers ', error);
      // TODO: should i create a custom error model
      // this.error = 'Error accessing auth data'
      this.error = error;
      return Promise.reject(error);
    }
  }
}

export class WorkspaceRPCSession extends RPCSession {
  constructor() {
    super();
    this.account = store.getters.activeAccountId; // capture active account
    if (!this.account) {
      throw new Error('cannot create an account rpc session without an account id');
    }
  }

  async headers() {
    try {
      const metadata = await super.headers(); // begin with parent class headers.
      if (this.account !== store.getters.activeAccountId) {
        throw new Error('active account does not match existing rpc session');
      }
      metadata.account = this.account;
      return Promise.resolve(metadata);
    } catch (error) {
      console.error('error retrieving account headers', error);
      // TODO: should i create a custom error model
      // this.error = 'Error accessing auth data'
      this.error = error;
      return Promise.reject(error);
    }
  }
}

export class ProjectRPCSession extends WorkspaceRPCSession {
  constructor() {
    super();
    this.project = store.getters.activeProjectId; // capture active project
    if (!this.project) {
      throw new Error('cannot create a project rpc session without a project id');
    }
  }

  async headers() {
    try {
      const metadata = await super.headers(); // begin with parent class headers.
      if (this.project !== store.getters.activeProjectId) {
        throw new Error('active project does not match existing rpc session');
      }
      metadata.project = this.project;
      return Promise.resolve(metadata);
    } catch (error) {
      console.error('error retrieving project headers', error);
      this.error = error;
      return Promise.reject(error);
    }
  }
}
